'use client';
import dynamic from 'next/dynamic';
import { PageLoading } from '@/app/Components/LoadingBubbles';
// Leaflet accesses window at module evaluation; isolate only the map canvas.
const MapPageClient = dynamic(() => import('./MapPageClient'), { ssr: false, loading: () => <PageLoading title="Campus map" description="Loading the interactive map." /> });
export default function MapPage() { return <MapPageClient />; }
